module.exports = __webpack_public_path__ + "static/media/parts_10.469e84ae.svg";